import React from 'react';
import { useLocation } from 'react-router-dom';

import { Content, Container, LegalContainer } from './Footer.styled';
import { usePatient } from 'hooks/usePatient/usePatient';
import { pageUrl } from 'utilities/pageUrl';
import { useBreakpoints } from 'utilities/useBreakpoints';

import { Contact } from './Contact/Contact';
import { Legal } from './Legal/Legal';
import { Logo } from './Legal/Logo';
import { Privacy } from './Legal/Privacy';

const Footer = ({ fixed, isNotFoundPage }: { fixed?: boolean; isNotFoundPage?: boolean }) => {
  const { isLoggedIn } = usePatient();
  const { isMobile } = useBreakpoints();
  const location = useLocation();
  const isBookingRoute = location.pathname.startsWith(pageUrl.booking.bookingQuiz());
  // routes using "SimpleLayout" that requires footer padding if patient is authenticated
  // (otherwise footer overlaps main/sidebar menu)
  const isPaddingRoute =
    isBookingRoute ||
    location.pathname.startsWith(pageUrl.viosPayment()) ||
    location.pathname.startsWith(pageUrl.viosPayments()) ||
    location.pathname.startsWith(pageUrl.changeEmail()) ||
    location.pathname.startsWith(pageUrl.virtualMeeting()) ||
    Boolean(isNotFoundPage);

  return (
    <Container $fixed={fixed ?? isBookingRoute} $addPadding={isPaddingRoute && Boolean(isLoggedIn)}>
      <Content>
        {isMobile && <Logo />}
        {!isMobile && <Legal />}
        <Contact isLoggedIn={Boolean(isLoggedIn)} />
        {isMobile && (
          <LegalContainer>
            <Privacy />
          </LegalContainer>
        )}
      </Content>
    </Container>
  );
};

export default Footer;
